export default __webpack_public_path__ + "static/media/crossicon_white.96b78c9e.svg";